/**
 * TextRenderer — plain text content. Used both for the generic `text` kind
 * and as the suspense fallback for `MarkdownRenderer` while react-markdown
 * loads, so a partial markdown bubble starts visibly populated.
 */
import React from 'react';
import type { ChatContentItem, TextContentItem } from '@wg/types';
import type { Renderer } from '../registry';

const TextRenderer: Renderer = ({ item }) => {
  // Discriminate against the wider union — fall back to whatever stringy
  // content the item exposes.
  const text =
    (item as TextContentItem).text ??
    String((item as ChatContentItem & { text?: string }).text ?? '');
  return <span className="wg-chat__text">{text}</span>;
};

export default TextRenderer;
